module.exports = __webpack_public_path__ + "static/hero-image-new-443d1e5a384274b686a1c813eaa41621.png";